<template>
  <main class="profile">
    <el-row>
      <el-col :span="6" class="avatar-content">
        <div class="avatar">
          <img
            :src="
              $store.state.user.avatar
                ? $store.state.user.avatar
                : `${publicPath}/girl3.png`
            "
            alt=""
          />
        </div>
        <div style="text-align: center; padding-bottom: 20px">
          <el-button type="small" @click="showAvatars"> 修改头像 </el-button>
        </div>
      </el-col>
      <el-col :span="18" class="info-container">
        <el-form
          ref="registerForm"
          :model="personForm"
          class="login-form"
          autocomplete="on"
          label-position="left"
          label-width="100px"
        >
          <h1>基本信息</h1>
          <el-form-item prop="account" label="登录账号">
            <el-input
              ref="username"
              v-model="personForm.account"
              placeholder="登录账号"
              name="account"
              type="text"
              tabindex="0"
              maxlength="30"
              autocomplete="on"
              readonly
              disabled
            />
          </el-form-item>
          <el-form-item prop="account" label="用户姓名">
            <el-input
              ref="username"
              v-model="personForm.usname"
              placeholder="用户姓名"
              name="account"
              type="text"
              tabindex="0"
              maxlength="30"
              autocomplete="on"
              readonly
              disabled
            />
          </el-form-item>
          <el-form-item prop="account" label="用户工号">
            <el-input
              ref="username"
              v-model="personForm.userCode"
              placeholder="用户工号"
              name="account"
              type="text"
              tabindex="0"
              maxlength="30"
              autocomplete="on"
              readonly
              disabled
            />
          </el-form-item>
          <el-form-item prop="account" label="职务">
            <el-input
              ref="username"
              v-model="personForm.orgName"
              placeholder="职务"
              name="account"
              type="text"
              tabindex="0"
              maxlength="30"
              autocomplete="on"
              readonly
              disabled
            />
          </el-form-item>
          <el-form-item prop="account" label="所属角色">
            <el-input
              ref="username"
              v-model="roles"
              placeholder="所属角色"
              name="account"
              type="text"
              tabindex="0"
              maxlength="30"
              autocomplete="on"
              readonly
              disabled
            />
          </el-form-item>
          <el-form-item prop="account" label="创建时间">
            <el-input
              ref="username"
              v-model="personForm.createTime"
              placeholder="创建时间"
              name="account"
              type="text"
              tabindex="0"
              maxlength="30"
              autocomplete="on"
              readonly
              disabled
            />
          </el-form-item>
          <el-form-item prop="account" label="更新时间">
            <el-input
              ref="username"
              v-model="personForm.updateTime"
              placeholder="更新时间"
              name="account"
              type="text"
              tabindex="0"
              maxlength="30"
              autocomplete="on"
              readonly
              disabled
            />
          </el-form-item>
          <el-divider></el-divider>
          <h1>详细信息</h1>
          <el-form-item prop="account" label="办公电话">
            <el-input
              ref="username"
              v-model="personForm.officePhone"
              placeholder="办公电话"
              name="account"
              type="text"
              tabindex="0"
              maxlength="30"
              autocomplete="on"
            />
          </el-form-item>
          <el-form-item prop="account" label="手机号码">
            <el-input
              ref="username"
              v-model="personForm.cellPhoneNumber"
              placeholder="手机号码"
              name="account"
              type="text"
              tabindex="0"
              maxlength="30"
              autocomplete="on"
            />
          </el-form-item>
          <el-form-item prop="account" label="家庭住址">
            <el-input
              ref="username"
              v-model="personForm.homeAddress"
              placeholder="家庭住址"
              name="account"
              type="text"
              tabindex="0"
              maxlength="30"
              autocomplete="on"
            />
          </el-form-item>
          <el-form-item prop="account" label="邮政编码">
            <el-input
              ref="username"
              v-model="personForm.postalCode"
              placeholder="邮政编码"
              name="account"
              type="text"
              tabindex="0"
              maxlength="30"
              autocomplete="on"
            />
          </el-form-item>
          <el-form-item prop="account" label="电子邮件">
            <el-input
              ref="username"
              v-model="personForm.email"
              placeholder="电子邮件"
              name="account"
              type="text"
              tabindex="0"
              maxlength="30"
              autocomplete="on"
            />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row style="text-align: center; margin-top: 10px">
      <el-button type="primary" @click="upDataPersonalInfor">保存</el-button
      ><el-button @click="upDataPersonalInforCancle">取消</el-button>
    </el-row>
    <!-- 弹出表格-->
    <el-dialog
      title="头像设置"
      v-if="innerVisible"
      :visible.sync="innerVisible"
      width="700px"
      class="avata-dialog"
      :close-on-click-modal="false"
      :modal-append-to-body="true"
      append-to-body
    >
      <div class="set-avatar">
        <div class="default-avatar">
          <div
            class="img-box"
            :key="item"
            v-for="item in defaultAvatars"
            @click="setDefaultAvatrar(item)"
          >
            <img :src="`${publicPath}${item}`" alt="" />
          </div>
        </div>
        <div class="upload-avatar">
          <el-upload
            class="avatar-uploader"
            :action="VUE_APP_UPLOAD_URL + '/sys/file/upload'"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="imageUrl" :src="imageUrl" />
            <img v-else :src="`${publicPath}/avatar-upload.png`" alt="" />
            <el-button type="primary">本地上传</el-button>
          </el-upload>
        </div>
      </div>
      <el-row style="text-align: center; height: 50px; margin-top: 10px">
        <el-button type="primary" @click="setAvatarStory">保存</el-button
        ><el-button @click="setAvatarCancle">取消</el-button>
      </el-row>
    </el-dialog>
  </main>
</template>

<script>
import { getPersonalInfor, upDataPersonalInfor,upDataAvatar } from "@/api/navbar/profile";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      person: null,
      personForm: {
        roles: [
          {
            name: "",
          },
        ],
      },
      roles:'',
      publicPath: process.env.VUE_APP_PROFILE_BASE_URL,
      defaultAvatars: [
        "/boy1.png",
        "/boy2.png",
        "/boy3.png",
        "/girl1.png",
        "/girl2.png",
        "/girl3.png",
      ],
      fileId: "",
      imageUrl: "",
      VUE_APP_UPLOAD_URL: process.env.VUE_APP_BASE_API,
      innerVisible: false,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getPersonalInfor();
  },
  mounted() {},
  methods: {
    //获取个人设置
    getPersonalInfor() {
      getPersonalInfor(this.$store.state.user.usid).then((res) => {
        this.personForm = res.data;
        res.data.roles.forEach(item=>{
             this.roles+=(this.roles?'，':'')+item.name;
        })
        
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.ok) {
        this.fileId = res.data.fileId;
        this.imageUrl =
          this.VUE_APP_UPLOAD_URL + `/sys/file/${this.fileId}/download`;
      } else {
        this.$message.error(res.message);
      }
    },
    //上传图片限制
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    //点击默认头像设置
    setDefaultAvatrar(publicUrl) {
      this.$message.success("设置成功，请保存！");
      this.$store.commit("user/SET_AVATAR", this.publicPath + publicUrl);
      this.imageUrl = this.publicPath + publicUrl;
      this.fileId = "";
      this.personForm.avatar = publicUrl;
    },
    upDataPersonalInfor() {
      upDataPersonalInfor(this.personForm).then((res) => {
        this.$message.success("保存成功！");
        this.$emit("closeDialog", "");
      });
    },
    //取消个人信息设置
    upDataPersonalInforCancle(){
      this.$emit("closeDialog", "");
    },
    showAvatars() {
      this.innerVisible = true;
    },
    setAvatarStory() {
      if (this.fileId) {
        this.personForm.avatar = this.fileId;
      }
      this.innerVisible = false;
      this.$store.commit("user/SET_AVATAR", this.imageUrl);
    },
    setAvatarCancle(){
       this.innerVisible = false;
    },
    dialogClose() {
      this.innerVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/mixin.scss";
.profile {
  height: 500px;
  width: 100%;
  .avatar-content {
    background: #fafafa;
    height: 100%;
    height: 450px;
    .avatar {
      img {
        width: 100px;
        height: 100px;
        margin: 20px auto;
        display: block;
        border-radius: 100px;
        border: 2px solid #fff;
      }
    }
  }
  .info-container {
    height: 450px;
    overflow: auto;
  }
}
.login-form {
  margin-left: 20px;
  h1 {
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 10px;
  }
}
.set-avatar {
  height: 350px;
  width: 700px;
  display: flex;
}
.avata-dialog ::v-deep.el-dialog__body {
  padding: 0px;
}
.upload-avatar {
  flex: 1 1 auto;
  text-align: center;
  background: #fafafa;
  img {
    margin: 20px 0px;
    border: 2px solid #fff;
    border-radius: 50%;
    height: 100px;
    width: 100px;
  }
}
.default-avatar {
  display: flex;
  width: 525px;
  flex-wrap: wrap;
  .img-box {
    width: 33.3%;
    text-align: center;
    padding: 20px 0;
    border: 1px solid #eee;
    img {
      width: 100px;
      height: 100px;
    }
  }
}
::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

::v-deep .el-dialog .el-dialog__body {
  padding-top: 0;
  padding-bottom: 10px;
  flex: 1 1 auto;
  overflow: auto;
}
</style>
